// extracted by mini-css-extract-plugin
export default {"container":"import-role_container__rV2PH","content":"import-role_content__B7Qon"};